require("intersection-observer");
// import polyfill from '@babel/polyfill'
if (window && !window.Promise) {
  require("core-js/es/promise");
}
if (!Promise.prototype.finally) {
  require("core-js/es/promise/finally");
}
if (window && !window?.Symbol?.asyncIterator) {
  require("core-js/es/symbol/async-iterator");
}

if (!Array.prototype.includes) {
  require("core-js/es/array/includes");
}
if (!Object.values) {
  require("core-js/es/object/values");
}
if (!Object.entries) {
  require("core-js/es/object/entries");
}
if (!Object.keys) {
  require("core-js/es/object/keys");
}
if (window && !window["WeakMap"]) {
  require("core-js/es/weak-map");
}
if (window && !window["WeakSet"]) {
  require("core-js/es/weak-set");
}

if (!window.ResizeObserver) {
  window.ResizeObserver = require("resize-observer-polyfill").default;
}
if (!window.queueMicrotask) {
  // window.queueMicrotask = require("queue-microtask");
  // typeof queueMicrotask === "function"
  //   ? queueMicrotask.bind(typeof window !== "undefined" ? window : global)
  //   : // reuse resolved promise, and allocate it lazily
  let promise = null;
  window.queueMicrotask = (cb) =>
    (promise || (promise = Promise.resolve())).then(cb).catch((err) =>
      setTimeout(() => {
        throw err;
      }, 0)
    );
}
if (!window.globalThis) {
  window.globalThis = window;
}

/* eslint-disable no-inner-declarations */
/* eslint-disable no-prototype-builtins */
//修复低版本浏览器本身的jsapi功能缺失的缺陷
//增加string的trim函数
if (typeof String.prototype.trim != "function") {
  Object.defineProperty(String.prototype, "trim", {
    value: function trim(maxLength, fillString) {
      let emptyBlockReg = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
      return this.replace(emptyBlockReg, "");
    },
    enumerable: false
  });
}
if (typeof String.prototype.padStart != "function") {
  Object.defineProperty(String.prototype, "padStart", {
    value: function padStart(maxLength, fillString) {
      let str = this;
      let length = str.length;
      let offset = maxLength - length;
      let arr = [];
      for (let i = 0; i < offset; i++) {
        arr.push(fillString);
      }
      return arr.join("") + str;
    },
    enumerable: false
  });
}
if (typeof String.prototype.padEnd != "function") {
  Object.defineProperty(String.prototype, "padEnd", {
    value: function padEnd(maxLength, fillString) {
      let str = this;
      let length = str.length;
      let offset = maxLength - length;
      let arr = [];
      for (let i = 0; i < offset; i++) {
        arr.push(fillString);
      }
      return str + arr.join("");
    },
    enumerable: false
  });
}
//增加string的startsWith
if (typeof String.prototype.startsWith != "function") {
  Object.defineProperty(String.prototype, "startsWith", {
    value: function startsWith(search, pos) {
      pos = !pos || pos < 0 ? 0 : +pos;
      return this.substring(pos, pos + search.length) === search;
    },
    enumerable: false
  });
}
//增加string的endsWith
if (typeof String.prototype.endsWith != "function") {
  Object.defineProperty(String.prototype, "endsWith", {
    value: function endsWith(search, this_len) {
      if (this_len === undefined || this_len > this.length) {
        this_len = this.length;
      }
      return this.substring(this_len - search.length, this_len) === search;
    },
    enumerable: false
  });
}
if (typeof String.prototype.replaceAll != "function") {
  Object.defineProperty(String.prototype, "replaceAll", {
    value: function replaceAll(regexp, input) {
      if (Object.prototype.toString.call(regexp) == "[object RegExp]") {
        if (!regexp.global) {
          throw new Error("String.prototype.replaceAll called with a non-global RegExp argument");
        }
        return this.replace(regexp, input);
      } else if (typeof regexp === "string") {
        let v = this;
        let arrs = v.split(regexp);
        v = arrs.join(input);
        return v;
      }
    },
    enumerable: false
  });
}
//兼容低版本浏览器没有forEach
if (typeof Array.prototype.forEach != "function") {
  Object.defineProperty(Array.prototype, "forEach", {
    value: function forEach(callback) {
      for (var i = 0; i < this.length; i++) {
        callback(this[i], i);
      }
    },
    enumerable: false
  });
}
//兼容低版本浏览器没有filter函数
if (typeof Array.prototype.filter != "function") {
  Object.defineProperty(Array.prototype, "filter", {
    value: function filter() {
      var result = [];
      for (var i = 0; i < this.length; i++) {
        var r = callback(this[i]);
        if (r === true) {
          result.push(this[i]);
        }
      }
      return result;
    },
    enumerable: false
  });
}
//兼容低版本浏览器没有flatMap函数
if (typeof Array.prototype.flatMap != "function") {
  Object.defineProperty(Array.prototype, "flatMap", {
    value: function flatMap() {
      return _.flatMap(this, callback);
    },
    enumerable: false
  });
}
//兼容低版本浏览器没有flat函数
if (typeof Array.prototype.flat != "function") {
  Object.defineProperty(Array.prototype, "flat", {
    value: function flat() {
      return _.flatten(this);
    },
    enumerable: false
  });
}
//兼容低版本浏览器没有classList
if (!("classList" in document.documentElement)) {
  Object.defineProperty(HTMLElement.prototype, "classList", {
    get: function () {
      var self = this;
      function update(fn) {
        return function (value) {
          var classes = self.className.split(/\s+/g),
            index = classes.indexOf(value);

          fn(classes, index, value);
          self.className = classes.join(" ");
        };
      }

      return {
        add: update(function (classes, index, value) {
          if (!~index) classes.push(value);
        }),

        remove: update(function (classes, index) {
          if (~index) classes.splice(index, 1);
        }),

        toggle: update(function (classes, index, value) {
          if (~index) classes.splice(index, 1);
          else classes.push(value);
        }),

        contains: function (value) {
          return !!~self.className.split(/\s+/g).indexOf(value);
        },

        item: function (i) {
          return self.className.split(/\s+/g)[i] || null;
        }
      };
    }
  });
}

//兼容IE下NodeList对象forEach
if (window.NodeList && !NodeList.prototype.forEach) {
  Object.defineProperty(NodeList.prototype, "forEach", {
    value: Array.prototype.forEach,
    enumerable: false
  });
}

//兼容元素没有matches函数
if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.matchesSelector ||
    Element.prototype.mozMatchesSelector ||
    Element.prototype.msMatchesSelector ||
    Element.prototype.oMatchesSelector ||
    Element.prototype.webkitMatchesSelector ||
    function (s) {
      var matches = (this.document || this.ownerDocument).querySelectorAll(s),
        i = matches.length;
      // eslint-disable-next-line no-empty
      while (--i >= 0 && matches.item(i) !== this) {}
      return i > -1;
    };
}
//兼容元素在IE中没有closest方法
if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = this;
    do {
      if (Element.prototype.matches.call(el, s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}
//兼容IE无toBlob
if (!HTMLCanvasElement.prototype.toBlob) {
  Object.defineProperty(HTMLCanvasElement.prototype, "toBlob", {
    value: function (callback, type, quality) {
      var canvas = this;
      setTimeout(function () {
        var binStr = atob(canvas.toDataURL(type, quality).split(",")[1]);
        var len = binStr.length;
        var arr = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
          arr[i] = binStr.charCodeAt(i);
        }

        callback(new Blob([arr], { type: type || "image/png" }));
      });
    }
  });
}

// 兼容ie没有scrollTo和scrollBy
if (!Element.prototype.scrollTo) {
  function scrollTo() {
    let opts = null;
    if (arguments.length == 2) {
      opts = {
        top: arguments[1],
        left: arguments[0]
      };
    } else if (arguments.length == 1) {
      opts = arguments[0];
    }
    if (opts) {
      if (opts.behavior === "smooth") {
        let params = {};
        if (opts.top !== void 0) params.scrollTop = opts.top;
        if (opts.left !== void 0) params.scrollLeft = opts.left;
        $(this).animate(params, 200);
      } else {
        this.scrollLeft = opts.left;
        this.scrollTop = opts.top;
      }
    }
  }
  Element.prototype.scrollTo = scrollTo;
  window.scrollTo = scrollTo;
}
if (!Element.prototype.scrollBy) {
  function scrollBy() {
    let opts = null;
    if (arguments.length == 2) {
      opts = {
        top: arguments[1],
        left: arguments[0]
      };
    } else if (arguments.length == 1) {
      opts = arguments[0];
    }
    if (opts) {
      if (opts.behavior === "smooth") {
        let params = {};
        if (opts.top !== void 0) params.scrollTop = opts.top + this.scrollTop;
        if (opts.left !== void 0) params.scrollLeft = opts.left + this.scrollLeft;
        $(this).animate(params, 200);
      } else {
        this.scrollLeft += opts.left;
        this.scrollTop += opts.top;
      }
    }
  }
  Element.prototype.scrollBy = scrollTo;
  window.scrollBy = scrollTo;
}

if (window.MediaQueryList) {
  if (!window.MediaQueryList.prototype.addEventListener) {
    window.MediaQueryList.prototype.addEventListener = function () {};
  }
  if (!window.MediaQueryList.prototype.removeEventListener) {
    window.MediaQueryList.prototype.removeEventListener = function () {};
  }
}
